import services from './../images/services.png';

const Services = () => {
    return (
      <div>
        <p className="standard-paragraph">
          <div class="container">
            <div class="image-container">
              <img src={services} alt="Services" width={300}/>
            </div>
            <div class="text-container">
              <h2>Services</h2>
              <p class="text-text">  
                Transform your digital landscape with our AWS-focused software development services, offering tailored solutions for 
                scalability, security, and innovation. Our dedicated team crafts robust applications, leveraging the power of AWS to 
                drive your business forward. Explore the full spectrum of our services and delve into additional resources on our page 
                to discover how we can shape your journey towards unparalleled success in the cloud.
              </p>
            </div>
          </div>
        </p>
      </div>
      )
  };
  
  export default Services;